import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment, memo, useContext, } from 'react';
import theme from '../../styles/theme';
import { TextLink } from '../TextLink/index';
import { PaginationContext } from './PaginationContext';
const linkContainerStyles = css `
  margin-right: ${theme.spacing.x3};
`;
const ViewAllLink = () => {
    const { isViewAllActive, onViewAllClick, onViewLessClick, } = (useContext(PaginationContext));
    return (isViewAllActive
        ? (_jsx(TextLink, { onClick: onViewLessClick, size: "small", text: "View Less", type: "secondaryAlternate" }))
        : (_jsx(Fragment, { children: _jsx("div", Object.assign({ css: linkContainerStyles }, { children: _jsx(TextLink, { onClick: onViewAllClick, size: "small", text: "View All", type: "secondaryAlternate" }) })) })));
};
const MemoizedViewAllLink = memo(ViewAllLink);
export { MemoizedViewAllLink as ViewAllLink };
